import { MSG_ERRO_SERVIDOR } from "../../../shared/constantes/mensagens";

const INITIAL_STATE = {
  alerta: {},
  cep: '',
  ufs: null,
  municipios: [],
  disponibilidades: [],
  utilizarCepRequerimentoUnicaVez: false,
  esperandoSolicitacao: false,
  retornoLocalizacao: null
};

export default (state = INITIAL_STATE, action) => {

  switch (action.type) {
    case 'REQUERIMENTO_DISPONIBILIDADE_SET_CEP':
      return { ...state, cep: action.payload }
    case 'REQUERIMENTO_DISPONIBILIDADE_SET_UTILIZAR_CEP_REQUERIMENTO_UNICA_VEZ':
        return { ...state, utilizarCepRequerimentoUnicaVez: action.payload }
    case 'REQUERIMENTO_DISPONIBILIDADE_BUSCARCEP_INICIO':
      return { ...state, alerta: {}, esperandoSolicitacao: true }
    case 'REQUERIMENTO_DISPONIBILIDADE_BUSCARLOCALIZACAO_SUCESSO':
      return { ...state, esperandoSolicitacao: false, disponibilidades: action.payload, retornoLocalizacao: true }
    case 'REQUERIMENTO_DISPONIBILIDADE_BUSCARLOCALIZACAO_ERROR':
      return { ...state, esperandoSolicitacao: false, alerta: { title: 'Erro: ', 
        message: typeof action.payload == "string" ? action.payload : MSG_ERRO_SERVIDOR, severity: 'error' }, retornoLocalizacao: false }
    case 'REQUERIMENTO_DISPONIBILIDADE_BUSCARCEP_SUCESSO':
      return { ...state, esperandoSolicitacao: false, disponibilidades: action.payload }
    case 'REQUERIMENTO_DISPONIBILIDADE_BUSCARCEP_ERROR':
      return { ...state, esperandoSolicitacao: false, alerta: { title: 'Erro: ', 
        message: typeof action.payload == "string" ? action.payload : MSG_ERRO_SERVIDOR, severity: 'error' } }
    case 'REQUERIMENTO_DISPONIBILIDADE_BUSCARMUNICIPIO_SUCESSO':
      return { ...state, esperandoSolicitacao: false, disponibilidades: action.payload }
    case 'REQUERIMENTO_DISPONIBILIDADE_BUSCARMUNICIPIO_ERROR':
      return { ...state, esperandoSolicitacao: false, alerta: { title: 'Erro: ', 
        message: typeof action.payload == "string" ? action.payload : MSG_ERRO_SERVIDOR, severity: 'error' } }
    case 'REQUERIMENTO_DISPONIBILIDADE_UFS_RECEBIDOS':
      return { ...state, ufs: action.payload, esperandoSolicitacao: false }
    case 'REQUERIMENTO_DISPONIBILIDADE_MUNICIPIOS_RECEBIDOS':
      return { ...state, municipios: action.payload, esperandoSolicitacao: false }
    case 'REQUERIMENTO_DISPONIBILIDADE_AVISO_ERROR':
      return { ...state, esperandoSolicitacao: false }
    default:
      return { ...state }
  }
}
